import React, { useRef, useCallback, useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { MediaQueries } from '../utils';
import { ProductCard, ComponentHeader } from '../Common';
import { Grid } from "swiper/modules";
import CarouselProducts from './CarouselProducts';
// import required modules

export default function HalfCarouselProducts({ products, url, type, bg_color, title, first_string_color, second_string_color, view_all, inner_bg, first_title, second_title }) {

  const { isMobile } = MediaQueries()

  const sliderRef = useRef(null);

  return (
    <div className={`carousel_products ${type == 2 && 'pt-4 px-3'}`} style={{ background: bg_color }}>
      <ComponentHeader first_title={first_title} second_title={second_title} url={url} title={title} first_string_color={first_string_color} second_string_color={second_string_color} view_all={view_all} />
      <CarouselProducts products={products} type={type} inner_bg={inner_bg} />
    </div>
  );
}
